// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function parseJson<T = any>(value: string, onError?: (error: Error) => void) {
    try {
        const parsed: T = JSON.parse(value);
        return parsed;
    } catch (error) {
        onError?.(error);
    }
}
